import React from "react";
import { Link } from "react-router-dom";
import "./Nav.css";

const ROBLOX_PROFILE_URL = "https://www.roblox.com/users/10501268419/profile/#!#creations";

export default function Nav() {
  return (
    <header className="nav">
      <div className="nav__inner">
        <Link to="/" className="nav__logo" aria-label="Yambotsu home">
          <img src="/logo.png" alt="Yambotsu" className="nav__logo-img" />
          <span className="nav__brand">Yambotsu</span>
        </Link>
        <div className="nav__right">
          <p className="nav__tagline">Finding the fun, fast.</p>
          <a
            href={ROBLOX_PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="nav__cta"
          >
            Play now
          </a>
        </div>
      </div>
    </header>
  );
}
